<template>
  <div class="flex w-full flex-col" data-cy="recent-note">
    <div
      class="flex cursor-pointer items-center space-x-1"
      @click="
        openActivityModal({
          model,
          activeTypes: [CommunicationType.note],
          isAllActivity,
        })
      "
    >
      <icon-base :icon="IconNotes" class="flex-none text-disabled-medium" />
      <div
        v-tooltipable
        class="line-clamp-1 whitespace-nowrap truncate text-headline hover:underline"
        data-cy="note"
      >
        {{ markdownToText(model.latest_note?.comment ?? "") }}
      </div>
    </div>
    <date-and-time-display
      v-if="model?.latest_note?.updated_at"
      :value="model.latest_note.updated_at"
      :show-time-below-date="false"
    />
  </div>
</template>

<script setup lang="ts">
import { useActivityModal } from "@/composables/useActivityModal";
import { CommunicationType } from "@/enums/communicationLogs";
import { markdownToText } from "@/helpers/formatting";

import IconNotes from "@/components/icons/IconNotes.vue";
import IconBase from "@/components/ui/IconBase.vue";
import DateAndTimeDisplay from "@/components/ui/text/DateAndTimeDisplay.vue";

import type { IApplication } from "@/models/applications";

interface Props {
  model: Pick<IApplication, "id" | "latest_note">;
  isAllActivity?: boolean;
}

const { model, isAllActivity = false } = defineProps<Props>();

const { openActivityModal } = useActivityModal();
</script>
